// Addresses of the site's pages that several places link to.

/** A video category's page: /categories/big-tits. */
export const categoryHref = (slug: string) => `/categories/${encodeURIComponent(slug)}`;
